import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import Breadcrumbs, { RouteLevel } from '~/components/Breadcrumbs';

const segmentBreadcrumbKeys: Record<string, string[]> = {
  overview: ['tabs.overview'],
  license: ['tabs.license'],
  'ai-tooling': ['tabs.aiTooling'],
  'plain-os': ['reImageSection', 'tabs.plainOS'],
  applications: ['reImageSection', 'tabs.applications'],
  access: ['tabs.access'],
  'ssh-keys': ['tabs.sshKeys'],
};

const SelfManagedBreadcrumbs = () => {
  const { t } = useTranslation('selfManagedHosting');
  const { pathname } = useLocation();
  const currentSegment = pathname.split('/').filter(Boolean).pop() ?? '';

  const trailingLevels: RouteLevel[] =
    segmentBreadcrumbKeys[currentSegment]?.map((key) => ({
      label: t(key),
    })) ?? [];

  const levels: RouteLevel[] = [
    { label: t('hostingTitle'), navigateTo: '/' },
    ...trailingLevels,
  ];

  return <Breadcrumbs levels={levels} />;
};

export default SelfManagedBreadcrumbs;
